// ******************* FETCH CONTINUE_WATCHING MOVIES - FOR ALL PRODUCTS *******************
export const CONTINUE_WATCHING_LOADING = 'CONTINUE_WATCHING_LOADING';
export const CONTINUE_WATCHING_SUCCESS = 'CONTINUE_WATCHING_SUCCESS';
export const CONTINUE_WATCHING_ERROR = 'CONTINUE_WATCHING_ERROR';

// ******************* CLEAR CONTINUE_WATCHING MOVIES DATA *******************
export const CLEAR_CONTINUE_WATCHING = 'CLEAR_CONTINUE_WATCHING';
